export default (params) => ({
  trigger: {
    name: 'product_type_section.select_upsell_alternative',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'upsell_collection',
        method: null,
      },
    },
  },
});
